import request from '@/utils/request'

const tradeClientMaterialApi = {
  trade_client_material_list: '/trade/client_material/',
  trade_client_material_create: '/trade/client_material/',
  trade_client_material_update: '/trade/client_material/',
  trade_client_material_delete: '/trade/client_material/'
}

/**
 * 列表
 */
export function client_material_list (parameter) {
  return request({
    url: tradeClientMaterialApi.trade_client_material_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function client_material_create (parameter) {
  return request({
    url: tradeClientMaterialApi.trade_client_material_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function client_material_update (parameter, client_material_id) {
  return request({
    url: tradeClientMaterialApi.trade_client_material_update + client_material_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function client_material_delete (client_material_id) {
  return request({
    url: tradeClientMaterialApi.trade_client_material_delete + client_material_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
